import { Box, IconButton, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import type { DashboardPeriodo } from '../hooks/useDashboard.js';

const MESES = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

interface Props {
  periodo: DashboardPeriodo;
  onChange: (p: DashboardPeriodo) => void;
}

export function PeriodoSelector({ periodo, onChange }: Props) {
  const agora = new Date();
  const isAtual = periodo.mes === agora.getMonth() + 1 && periodo.ano === agora.getFullYear();

  function anterior() {
    if (periodo.mes === 1) onChange({ mes: 12, ano: periodo.ano - 1 });
    else onChange({ mes: periodo.mes - 1, ano: periodo.ano });
  }

  function proximo() {
    if (isAtual) return;
    if (periodo.mes === 12) onChange({ mes: 1, ano: periodo.ano + 1 });
    else onChange({ mes: periodo.mes + 1, ano: periodo.ano });
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <IconButton size="small" onClick={anterior}>
        <ChevronLeftIcon fontSize="small" />
      </IconButton>
      <Typography variant="body2" fontWeight={600} sx={{ minWidth: 72, textAlign: 'center' }}>
        {MESES[periodo.mes - 1]}/{periodo.ano}
      </Typography>
      <IconButton size="small" onClick={proximo} disabled={isAtual}>
        <ChevronRightIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
